
import { Vue, Options } from 'vue-class-component';
import CameraStatusDetails from "@/components/common/CameraStatusDetails.vue";
import { Prop } from "vue-property-decorator";
import { Camera } from "@/api";
import NHint from "@/uikit/hint/NHint.vue";
import {
  computeCameraStatusDetailFromFramesDropped, computeCameraStatusDetailFromJobStarts,
  computeCameraStatusDetailFromObjectsNotPosted,
  computeCameraStatusDetailFromObjectsPosted,
  computeCameraStatusDetailFromProcessDuration,
  computeCameraStatusDetailFromStatus
} from "@/pages/data-sources/forms/components/utils";

@Options({
  name: 'CameraStatusInfo',
  components: { CameraStatusDetails, NHint },
  inheritAttrs: false,
})
export default class CameraStatusInfo extends Vue {
  @Prop({ type: Object, required: true })
  readonly item!: Camera;

  get statusLabel() {
      return this.$t('ds.status__' + (this.item.health_status?.status || '').toLowerCase(), 'f');
  }

  get details() {
    return [
      { label: this.$t('ds.status'), value: this.statusLabel },
      {
        label: this.$t('ds.process_duration'),
        value: computeCameraStatusDetailFromProcessDuration(this.item.health_status)
      },
      {
        label: this.$t('ds.objects_posted'),
        value: computeCameraStatusDetailFromObjectsPosted(this.item.health_status)
      },
      {
        label: this.$t('ds.objects_not_posted'),
        value: computeCameraStatusDetailFromObjectsNotPosted(this.item.health_status)
      },
      {
        label: this.$t('ds.frames_dropped'),
        value: computeCameraStatusDetailFromFramesDropped(this.item.health_status)
      },
      { label: this.$t('ds.job_starts'), value: computeCameraStatusDetailFromJobStarts(this.item.health_status) }
    ];
  }

  get statusDescription() {
    return this.item.health_status.code_desc;
  }
}
